import { Component } from '@angular/core';
import { SocialLoginService } from '../../Services/social-login.service';

@Component({
  selector: 'app-homepage-app',
  standalone: false,
  templateUrl: './homepage-app.component.html',
  styleUrl: './homepage-app.component.css'
})
export class HomepageAPPComponent {
  textToType: string = "Finger tips.";
  typedText: string = "";
  showText: boolean = true;
  typingSpeed: number = 100; 
  eraseSpeed: number = 50;
  delayBeforeErase: number = 1500; 
  index: number = 0;
  isErasing: boolean = false;
  platform:string=''
  constructor(private authsocial:SocialLoginService){
     this.authsocial.Getplarform().then(x=>{
      this.platform=x
     })
  }

  ngOnInit() {
    this.authsocial.Getplarform().then(x=>{
      this.platform=x
     })
    this.startTyping();
  }

  startTyping() {
    if (!this.isErasing) {
      if (this.index < this.textToType.length) {
        this.typedText += this.textToType[this.index];
        this.index++;
        setTimeout(() => this.startTyping(), this.typingSpeed);
      } else {
        // Wait before erasing
        setTimeout(() => {
          this.isErasing = true;
          this.startErasing();
        }, this.delayBeforeErase);
      }
    }
  }

  startErasing() {
    if (this.isErasing) {
      if (this.typedText.length > 0) {
        this.typedText = this.typedText.slice(0, -1);
        setTimeout(() => this.startErasing(), this.eraseSpeed);
      } else {
        // Restart typing after erasing
        this.isErasing = false;
        this.index = 0;
        setTimeout(() => this.startTyping(), this.typingSpeed);
      }
    }
  }
}
